<div class="rl-right">

  <!-- ── Tab navigation ── -->
  <div class="rl-right-tabs">
    <button class="rl-right-tab-btn" [class.active]="currentTab === 0" (click)="currentTab = 0">
      {{ 'leave_management.leave_holiday_panel.company_holiday' | transloco }}
    </button>
    <button class="rl-right-tab-btn" [class.active]="currentTab === 1" (click)="currentTab = 1">
      {{ 'leave_management.leave_holiday_panel.optional_holiday' | transloco }}
    </button>
    <button class="rl-right-tab-btn" [class.active]="currentTab === 2" (click)="currentTab = 2">
      {{ 'leave_management.leave_holiday_panel.compoff' | transloco }}
    </button>
  </div>

  <!-- ── Company Holiday tab ── -->
  @if (currentTab === 0) {
  <div class="right-panel">
    <ers-grid
      [rowData]="companyHolidayRows()" [columnDefs]="holidayColDefs()"
      [gridOptions]="{ suppressCellFocus: true, pagination: false, domLayout: 'autoHeight', headerHeight: 38 }">
    </ers-grid>
  </div>
  }

  <!-- ── Optional Holiday tab ── -->
  @if (currentTab === 1) {
  <div class="right-panel">
    <ers-grid
      [rowData]="optionalHolidayRows()" [columnDefs]="holidayColDefs()"
      [gridOptions]="{ suppressCellFocus: true, pagination: false, domLayout: 'autoHeight', headerHeight: 38 }">
    </ers-grid>
  </div>
  }

  <!-- ── Compoff tab ── -->
  @if (currentTab === 2) {
  <div class="right-panel compoff-panel">

    <div class="compoff-grid-section">
      <ers-grid
        [rowData]="pendingWorkedRows()" [columnDefs]="workedDateColDefs()"
        [gridOptions]="{ suppressCellFocus: true, pagination: false, domLayout: 'autoHeight', headerHeight: 38 }">
      </ers-grid>
    </div>

    <!-- Taken CompOff card — only shown when parent opts in via [showTakenCompOffCard]="true" -->
    @if (showTakenCompOffCard()) {
    <div class="taken-compoff-card">
      <div class="tc-header">{{ 'leave_management.leave_holiday_panel.taken_compoff' | transloco }}</div>
      @for (tc of takenCompOffs(); track $index) {
      <div class="tc-row">
        <span class="tc-worked">{{ formatTakenWorkedRange(tc) }}</span>
        <span class="tc-requested">{{ formatTakenRequestedRange(tc) }}</span>
        <span class="tc-status" [ngClass]="tc.status.toLowerCase()">
          {{ tc.status }}
          <span class="dot"></span>
        </span>
      </div>
      }
    </div>
    }

  </div>
  }

</div>
